import { mapGetters, mapActions } from 'vuex'

export default {
  computed:{
    ...mapGetters('auth', ['isAuthenticated', 'user', 'role_modules'])
  },
  methods: {
    ...mapActions('auth', ['SET_AUTH', 'SET_MODULES', 'login']),
    async loginUser() {
      const user = {
        email: this.model.email,
        password: this.model.password,
      };
    
      // If validation fails, immediately return a message
      if (this.validateForm()) {
        return { success: false, message: 'Invalid email and password.' };
      }
    
      this.toggleLoading();
      try {
        const res = await this.login(user);
    
        if (res.data.success) {
          this.setAuth(res.data);
          this.$router.push('/job');
        }
    
        // Whether success or not, return the API's message
        // (Assumes your API responds with { success: boolean, message: string, ... })
        return {
          success: res.data.success,
          message: res.data.message || 'No message returned.',
        };
      } catch (err) {
        // Attach server‑side field errors
        if (this.$v && err.response && err.response.data) {
          Object.keys(err.response.data).forEach(key => {
            this.$v.model[key].errorMessage = err.response.data[key];
          });
        }
    
        // Return the error message
        const fallback =
          err.response?.data?.password ??
          err.response?.data?.email ??
          'An unexpected error occurred.';

        return { success: false, message: fallback };
      } finally {
        this.toggleLoading();
      }
    },
    
    setAuth(payload) {
      this.SET_MODULES(payload)
      this.SET_AUTH(payload)
      this.$router.push('/')
    },
    logout(){
      this.SET_AUTH()
      this.SET_MODULES()
      this.$router.push('/login')
    },
    getToken(){
      return localStorage.getItem('token')
    }
  }
}